export default "__VITE_ASSET__DnL0NbBY__"